
<span class="ws-period ws-typo-xs">
  {{
    period % 12 !== 0
      ? $t('wsk.general.period.months', {period})
      : $t('wsk.general.period.years', {period: period / 12})
  }}
</span>
